import {
    SERVICE_DETAILS
  } from '../constants/AppConstants';
  
  const initialState = {
    serviceSEOName: '',
    categorySEOName: ''
  };
  
  export default (state = initialState, action) => {
    
    switch (action.type) {
      case SERVICE_DETAILS: {
        return {
          ...state,
          serviceSEOName: action.serviceSEOName,
          categorySEOName: action.categorySEOName
        }
      }
      
      default: {
        return state;
      }
    }
  };
  